import slugify from 'slugify'
import GetNewsroomUrls from './getNewsroomUrls'

const previewContentType = (type) => {
  return `Contentful${type?.charAt(0)?.toUpperCase() + type?.slice(1)}`
}

const transformLink = (
  linkItem,
  isALinkToAPage = true,
  isFromAlgolia = false,
) => {
  if (!linkItem)
    return {
      url: null,
      external: false,
      mailto: false,
      contentTypeContentful: null,
    }

  let url = null
  let mailto = false
  let external = false
  let contentTypeContentful = null
  const re = new RegExp('^(http|https)://', 'i')
  const isMail =
    /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/ // eslint-disable-line

  if (linkItem) {
    let pageLink
    let locale
    let contentType: string | null = null
    let title, slug, parentPageSlug

    if (!isALinkToAPage) {
      pageLink = linkItem
      locale = linkItem.sys ? linkItem.sys.locale : linkItem.node_locale
      title = linkItem.fields ? linkItem.fields.title : linkItem.title
      slug = linkItem.fields ? linkItem.fields.slug : linkItem.slug
      parentPageSlug = linkItem.fields
        ? linkItem.fields.parentPage?.slug
        : linkItem.parentPage?.slug
    } else if (linkItem.pageLink) {
      pageLink = linkItem.pageLink.fields
        ? linkItem.pageLink.fields
        : linkItem.pageLink
      locale = linkItem.pageLink.fields
        ? linkItem.pageLink.sys.locale
        : linkItem.pageLink.node_locale
      title = pageLink.title
      slug = pageLink.slug
      parentPageSlug = linkItem.parentPage?.slug

      if (linkItem.label === 'Le Labo') console.log(pageLink, locale, title, slug, parentPageSlug)
    }
    if (pageLink && pageLink.internal) {
      contentType = pageLink.internal.type
    } else if (
      isALinkToAPage &&
      linkItem.pageLink &&
      linkItem.pageLink.sys &&
      linkItem.pageLink.sys.contentType
    ) {
      contentType = previewContentType(linkItem.pageLink.sys.contentType.sys.id)
    } else if (!isALinkToAPage) {
      if (isFromAlgolia) {
        contentType = previewContentType(linkItem.contentType)
      } else if (linkItem.sys && linkItem.sys.contentType) {
        contentType = previewContentType(linkItem.sys.contentType.sys.id)
      }
    }

    contentTypeContentful = contentType

    const newsroomListUrls = [
      'ContentfulEvent',
      'ContentfulNews',
      'ContentfulAction',
    ]
    const slugUrls = [
      'ContentfulSimulator',
      'ContentfulDatasOdre',
      'ContentfulPage',
      'ContentfulContact',
      'ContentfulGovernance',
      'ContentfulHub',
      'ContentfulMap',
      'ContentfulNewsroomList',
      'ContentfulProfile',
      'ContentfulSearch',
    ]
    let newsroomUrls = null

    if (slugUrls.includes(contentType)) {
      if (contentType !== 'ContentfulPage') {
        contentType = 'slugPages'
      } else {
        if (pageLink.customType === 'Médiathèque') {
          contentType = 'medias'
          newsroomUrls = GetNewsroomUrls()
        } else if (pageLink.customType === 'Blog') {
          contentType = 'blog'
          newsroomUrls = GetNewsroomUrls()
        } else {
          contentType = 'slugPages'
        }
      }
    } else {
      if (newsroomListUrls.indexOf(contentType) !== -1) {
        newsroomUrls = GetNewsroomUrls()
      }
    }

    const slugifiedTitle = slugify(title ?? '', {
      remove: /[*+~.()'"!?:@,]/g,
    }).toLowerCase()
    const isFr = locale === 'fr'

    switch (contentType) {
      case 'ContentfulNews':
        if (isALinkToAPage && locale === undefined) {
          locale = linkItem.pageLink.fields
            ? linkItem.pageLink.sys.locale
            : linkItem.pageLink.node_locale
        }
        url = `/${newsroomUrls['Actualités'][locale]}/${slugifiedTitle}`
        break
      case 'ContentfulAction':
        url = `${isFr ? '/' : '/en/'}${parentPageSlug ?? ''}${parentPageSlug ? '/' : ''}${slugifiedTitle}`
        break
      case 'ContentfulProject':
        url = `${isFr ? '/projet' : '/en/project'}/${slugifiedTitle}`
        break
      case 'ContentfulEvent':
        url = `/${newsroomUrls['Événements'][locale]}/${slugifiedTitle}`
        break
      case 'medias':
        url = `/${newsroomUrls['Médiathèque'][locale]}/${slugifiedTitle}`
        break
      case 'blog':
        url = `/${newsroomUrls['Blog'][locale]}/${slugifiedTitle}`
        break
      case 'ContentfulLabo':
        url = `${isFr ? '/labo' : '/en/lab'}/${slugifiedTitle}`
        break
      case 'slugPages':
        url = `${isFr ? '/' : '/en/'}${slug}`
        break
      case 'ContentfulHomepage':
        url = `${isFr ? '/' : '/en'}`
        break
      default:
        url = null
    }
    if (linkItem.assetLink) {
      let assetLink = linkItem.assetLink.fields
        ? linkItem.assetLink.fields
        : linkItem.assetLink
      url = assetLink.file ? assetLink.file.url : null
      external = true
    } else if (linkItem.customLink) {
      url = linkItem.customLink
      if (url) {
        if (url.match(re)) {
          external = true
        } else if (isMail.test(url)) {
          mailto = true
          external = true
        }
      }
    }
  }

  return { url, external, mailto, contentTypeContentful }
}

export default transformLink
